import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-34cc9f52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 3,
  class: "menu-icon",
  for: "menu-button"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "nav-icon" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 4,
  class: "menu"
}
const _hoisted_7 = { class: "language-selection" }
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("nav", null, [
    (_ctx.windowWidth > 768)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, "BRENDA CAYZAC"))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          height: "40",
          src: _ctx.getImgUrl('white_thumbnail', 'png'),
          alt: "Brand"
        }, null, 8, _hoisted_2)),
    (_ctx.windowWidth < 768)
      ? _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 2,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showMenu) = $event)),
          class: "menu-button",
          type: "checkbox",
          id: "menu-button"
        }, null, 512)), [
          [_vModelCheckbox, _ctx.showMenu]
        ])
      : _createCommentVNode("", true),
    (_ctx.windowWidth < 768)
      ? (_openBlock(), _createElementBlock("label", _hoisted_3, _hoisted_5))
      : _createCommentVNode("", true),
    (_ctx.showMenu || _ctx.windowWidth > 768)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routes.slice(0, 4), (route, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              _createVNode(_component_router_link, {
                to: route.path
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(route.name.toString() === "commissions"
            ? _ctx.$tc("commission", 2)
            : _ctx.$t(route.name.toString())), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128)),
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_font_awesome_icon, {
              icon: "fa-solid fa-globe",
              transform: _ctx.fontAwesomeStyling
            }, null, 8, ["transform"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.languages, (language, i) => {
              return (_openBlock(), _createElementBlock("span", {
                key: i,
                onClick: ($event: any) => (_ctx.changeSelectedLanguage(language.language, language.shortLang)),
                class: _normalizeClass({
            'selected-language': language.language === _ctx.selectedLanguage,
          }),
                tabindex: "0",
                role: "menuitem"
              }, _toDisplayString(_ctx.windowWidth > 1000 ? language.language : language.shortLang), 11, _hoisted_8))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}